import type { ComponentType, SVGProps } from 'react';

import { Link } from '@/core/i18n/navigation';
import { envConfigs } from '@/config';

export interface FooterColumn {
  title: string;
  links: { label: string; href: string; external?: boolean }[];
}
export interface FooterSocial {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  href: string;
  label: string;
}
export function SiteFooter({
  tagline,
  columns = [],
  copyright,
}: {
  tagline?: string;
  columns?: FooterColumn[];
  socials?: FooterSocial[];
  copyright?: string;
}) {
  return (
    <footer className="crt-footer">
      <div className="crt-container">
        <div className="crt-footer-grid">
          <div>
            <Link className="crt-brand" href="/">
              {envConfigs.app_name}
            </Link>
            <p className="crt-muted">{tagline}</p>
          </div>
          {columns.map((column) => (
            <div key={column.title}>
              <h2>{column.title}</h2>
              <ul>
                {column.links.map((link) => (
                  <li key={link.href}>
                    <Link href={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="crt-copyright">
          {copyright || `© ${new Date().getFullYear()} ${envConfigs.app_name}`}
        </p>
      </div>
    </footer>
  );
}
